export const sortTypes = {
  sortUp: "sortUp",
  sortDown: "sortDown",
  sortDafault: "sortDafault",
};
